var _excluded = ["fontSize", "color", "text", "className"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/**
 * done
 */
import cx from 'classnames';
import React from 'react';
import { useCssInJs, wrapReactionHook } from "../../hooks";
import { genHelpStyles } from "./styles";
export var Help = wrapReactionHook(function (props) {
  var fontSize = props.fontSize,
    color = props.color,
    text = props.text,
    className = props.className,
    rest = _objectWithoutProperties(props, _excluded);
  var prefix = 'form-help';
  var _useCssInJs = useCssInJs({
      prefix: prefix,
      styleFun: genHelpStyles
    }),
    wrapSSR = _useCssInJs.wrapSSR,
    hashId = _useCssInJs.hashId;
  return wrapSSR( /*#__PURE__*/React.createElement("div", _extends({
    style: {
      fontSize: fontSize,
      color: color
    },
    className: cx(hashId, prefix, className)
  }, rest), text !== null && text !== void 0 ? text : '-'));
});